import { axiosCompanyPortalInstance } from "./";

const getCompanyPortalWorkingLogs = (params = {}) =>
  axiosCompanyPortalInstance.get("/working_logs", { params });

const exportCompanyPortalWorkingLogsReport = (params = {}) =>
  axiosCompanyPortalInstance.get("/working_logs/export_report", { params });

const getCompanyPortalWorkingSlots = (params = {}) =>
  axiosCompanyPortalInstance.get("/working_slots", { params });

const addCompanyPortalWorkingSlot = ({ data }) =>
  axiosCompanyPortalInstance.post("/working_slots", data, { handlerEnabled: false });

const editCompanyPortalWorkingSlot = ({ id, data }) =>
  axiosCompanyPortalInstance.patch(`/working_slots/${id}`, data, {
    handlerEnabled: false,
  });

const deleteCompanyPortalWorkingSlot = ({ id }) =>
  axiosCompanyPortalInstance.delete(`/working_slots/${id}`);

const getCompanyPortalTrainingWorkingSlots = (params = {}) =>
  axiosCompanyPortalInstance.get("/training_working_slots", { params });

const addCompanyPortalTrainingWorkingSlot = ({ data }) =>
  axiosCompanyPortalInstance.post("/training_working_slots", data, {
    handlerEnabled: false,
  });

const editCompanyPortalTrainingWorkingSlot = ({ id, data }) =>
  axiosCompanyPortalInstance.patch(`/training_working_slots/${id}`, data, {
    handlerEnabled: false,
  });

const deleteCompanyPortalTrainingWorkingSlot = ({ id }) =>
  axiosCompanyPortalInstance.delete(`/training_working_slots/${id}`);

export {
  getCompanyPortalWorkingLogs,
  exportCompanyPortalWorkingLogsReport,
  getCompanyPortalWorkingSlots,
  addCompanyPortalWorkingSlot,
  editCompanyPortalWorkingSlot,
  deleteCompanyPortalWorkingSlot,
  getCompanyPortalTrainingWorkingSlots,
  addCompanyPortalTrainingWorkingSlot,
  editCompanyPortalTrainingWorkingSlot,
  deleteCompanyPortalTrainingWorkingSlot,
};
